export const TOKEN_COOKIE = "token"